import type colors from '#ui-colors'

export type NotificationColor = 'gray' | typeof colors[number]

export const ERROR_TOAST = {
  title: 'Error',
  description: 'There was an error',
  color: 'red',
  icon: 'ri:error-warning-line',
}

export const SECTION_DEFAULT: Section = {
  buttons: [],
  collectionId: 'rf9oscl4teftfp6',
  collectionName: 'sections',
  created: '',
  description: '',
  id: '',
  image: '',
  images: [],
  subtitle: '',
  title: '',
  type: '',
  updated: '',
}

export const PAGE_COLLECTION_ID = 'xvp5x66effxpuq7'
export const PAGE_DEFAULT: Page = {
  created: '',
  updated: '',
  id: '',
  collectionName: 'pages',
  collectionId: 'xvp5x66effxpuq7',
  name: '',
  slug: '',
  meta_description: '',
  meta_image: '',
  published: false,
  sections: [],
}

export const EMAIL_DEFAULT: Email = {
  title: '',
  html: '',
  published: false,
  hook: 'create',
  collection: 'business',
  collectionId: '',
  collectionName: '',
  created: '',
  updated: '',
  id: '',
}

export const BASE_EMAIL = `
<!DOCTYPE html>
<html lang="en" xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml"
  xmlns:o="urn:schemas-microsoft-com:office:office">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="x-apple-disable-message-reformatting">
  <title>{{ .title}}</title>

  <link href="https://fonts.googleapis.com/css?family=Inter:200,300,400,500,600,700" rel="stylesheet">

  <style>
    html,
    body {
      margin: 0 auto !important;
      padding: 0 !important;
      height: 100% !important;
      width: 100% !important;
      background: #f1f5f9 ;
    }

    * {
      -ms-text-size-adjust: 100%;
      -webkit-text-size-adjust: 100%;
    }

    div[style*="margin: 16px 0"] {
      margin: 0 !important;
    }

    table,
    td {
      mso-table-lspace: 0pt !important;
      mso-table-rspace: 0pt !important;
    }

    table {
      border-spacing: 0 !important;
      border-collapse: collapse !important;
      table-layout: fixed !important;
      margin: 0 auto !important;
    }

    img {
      -ms-interpolation-mode: bicubic;
    }

    a {
      text-decoration: none;
    }

    *[x-apple-data-detectors],
    /* iOS */
    .unstyle-auto-detected-links *,
    .aBn {
      border-bottom: 0 !important;
      cursor: default !important;
      color: inherit !important;
      text-decoration: none !important;
      font-size: inherit !important;
      font-family: inherit !important;
      font-weight: inherit !important;
      line-height: inherit !important;
    }

    /* What it does: Prevents Gmail from displaying a download button on large, non-linked images. */
    .a6S {
      display: none !important;
      opacity: 0.01 !important;
    }

    /* What it does: Prevents Gmail from changing the text color in conversation threads. */
    .im {
      color: inherit !important;
    }

    /* If the above doesn't work, add a .g-img class to any image in question. */
    img.g-img+div {
      display: none !important;
    }

    /* What it does: Removes right gutter in Gmail iOS app: https://github.com/TedGoas/Cerberus/issues/89  */
    /* Create one of these media queries for each additional viewport size you'd like to fix */

    /* iPhone 4, 4S, 5, 5S, 5C, and 5SE */
    @media only screen and (min-device-width: 320px) and (max-device-width: 374px) {
      u~div .email-container {
        min-width: 320px !important;
      }
    }

    /* iPhone 6, 6S, 7, 8, and X */
    @media only screen and (min-device-width: 375px) and (max-device-width: 413px) {
      u~div .email-container {
        min-width: 375px !important;
      }
    }

    /* iPhone 6+, 7+, and 8+ */
    @media only screen and (min-device-width: 414px) {
      u~div .email-container {
        min-width: 414px !important;
      }
    }
  </style>

  <!-- CSS Reset : END -->

  <!-- Progressive Enhancements : BEGIN -->
  <style>
    .primary {
      background: #009881;
    }

    .bg_white {
      background: #ffffff;
    }

    .bg_light {
      background: #fafafa;
    }

    .bg_black {
      background: #000000;
    }

    .bg_dark {
      background: rgba(0, 0, 0, .8);
    }

    .email-section {
      padding: 2.5em;
    }

    /*BUTTON*/
    .btn {
      padding: 5px 15px;
      display: inline-block;
    }

    .btn.btn-primary {
      border-radius: 30px;
      background: #009881;
      color: #ffffff;
    }

    .btn.btn-white {
      border-radius: 30px;
      background: #ffffff;
      color: #000000;
    }

    .btn.btn-white-outline {
      border-radius: 30px;
      background: transparent;
      border: 1px solid #fff;
      color: #fff;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: 'Inter', sans-serif;
      color: #000000;
      margin-top: 0;
      font-weight: 700;
    }

    body {
      font-family: 'Inter', sans-serif;
      font-weight: 400;
      font-size: 15px;
      line-height: 1.8;
      color: rgba(0, 0, 0, .4);
    }

    a {
      color: #009881;
    }

    table {}

    /*LOGO*/

    .logo h1 {
      margin: 0;
    }

    .logo h1 a {
      color: #000000;
      font-size: 20px;
      font-weight: 700;
      text-transform: uppercase;
      font-family: 'Inter', sans-serif;
    }

    .navigation {
      padding: 0;
    }

    .navigation li {
      list-style: none;
      display: inline-block;
      text-transform: uppercase;
      margin-left: 5px;
      font-size: 13px;
      font-weight: 700;
    }

    .navigation li a {
      color: rgba(0, 0, 0, .4);
    }

    /*HERO*/
    .hero {
      position: relative;
      z-index: 0;
    }

    .hero .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      width: 100%;
      background: #000000;
      z-index: -1;
      opacity: .3;
    }

    .hero .text {
      color: rgba(255, 255, 255, .9);
    }

    .hero .text h2 {
      color: #fff;
      font-size: 50px;
      margin-bottom: 0;
      font-weight: 300;
      line-height: 1;
    }

    .hero .text h2 span {
      font-weight: 600;
      color: #009881;
    }


    /*HEADING SECTION*/
    .heading-section {}

    .heading-section h2 {
      color: #000000;
      font-size: 28px;
      margin-top: 0;
      line-height: 1.4;
      font-weight: 700;
      text-transform: uppercase;
    }

    .heading-section .subheading {
      margin-bottom: 20px !important;
      display: inline-block;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: rgba(0, 0, 0, .4);
      position: relative;
    }

    .heading-section .subheading::after {
      position: absolute;
      left: 0;
      right: 0;
      bottom: -10px;
      content: '';
      width: 100%;
      height: 2px;
      background: #009881;
      margin: 0 auto;
    }

    .heading-section-white {
      color: rgba(255, 255, 255, .8);
    }

    .heading-section-white h2 {
      font-family: 'Inter', sans-serif;
      line-height: 1;
      padding-bottom: 0;
    }

    .heading-section-white h2 {
      color: #ffffff;
    }

    .heading-section-white .subheading {
      margin-bottom: 0;
      display: inline-block;
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 2px;
      color: rgba(255, 255, 255, .4);
    }


    /*BLOG*/
    .text-services .meta {
      text-transform: uppercase;
      font-size: 14px;
      margin-bottom: 0;
    }

    /*FOOTER*/

    .footer {
      color: rgba(255, 255, 255, .8);
      background-color: #0165b2;
      margin-bottom: 20px;
    }

    .footer .heading {
      color: #ffffff;
      font-size: 20px;
    }

    .footer ul {
      margin: 0;
      padding: 0;
    }

    .footer ul li {
      list-style: none;
      margin-bottom: 10px;
    }

    .footer ul li a {
      color: rgba(255, 255, 255, 1);
    }


    @media screen and (max-width: 500px) {}
  </style>


</head>

<body width="100%" style="margin: 0; padding: 0 !important; mso-line-height-rule: exactly;">
  <center style="width: 100%; background-color: #f1f5f9; margin-top:20px; margin-bottom:20px;">
    <div
      style="display: none; font-size: 1px;max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden; mso-hide: all; font-family: sans-serif;">
      &zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;&zwnj;&nbsp;
    </div>
    <div style="max-width: 600px; margin: 0 auto;" class="email-container">
      <!-- BEGIN BODY -->
      <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
        style="margin: auto;">
        <tr class="bg_white">
        <td>
        <img src="/GBF-Logo.png" alt="logo" width="1100" height="209" style="width: 100%; height: auto; padding:1rem; margin: 0 auto; display: block;">
        </td>
        </tr>
       
        <tr>
          <td class="bg_white email-section">
            {{{{ body }}}}
          </td>
        </tr>
      </table>
      <table align="center" role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%"
        style="margin: auto;">
        <tr>
          <td valign="middle" class="footer email-section">
            <table>
              <tr>
                <td valign="top" width="50%" style="padding-top: 20px;">
                  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr>
                      <td style="text-align: left; padding-right: 10px;">
                        <h3 class="heading">About</h3>
                        <p>We are here to help local people find local businesses.
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
                <td valign="top" width="50%" style="padding-top: 20px;">
                  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr>
                      <td style="text-align: left; padding-left: 5px; padding-right: 5px;">
                        <h3 class="heading">Contact Info</h3>
                        <ul>
                          <li><a href=""><span class="text">Facebook Group</span></a></li>
                        </ul>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr><!-- end: tr -->
        <tr>
          <td valign="middle" class="footer email-section">
            <table>
              <tr>
                <td valign="top" width="33.333%">
                  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr>
                      <td style="text-align: left; padding-right: 10px;">
                        <p>&copy; All Rights Reserved</p>
                      </td>
                    </tr>
                  </table>
                </td>
                <td valign="top" width="33.333%">
                  <table role="presentation" cellspacing="0" cellpadding="0" border="0" width="100%">
                    <tr>
                      <td style="text-align: right; padding-left: 5px; padding-right: 5px;">
                        <p><span style="color: rgba(255,255,255,.4);">You are receiving this email because you signed up
                            to our platform. </span></p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>

    </div>
  </center>
</body>

</html>

`
export const BUSINESS_COLLECTION_ID = '2mjmjkzj5ewg88o'
export const REVIEW_COLLECTION_ID = 'bvpxfg2f2ysg2zg'
export const BUSINESS_DEFAULT: BusinessBase = {
  id: '',
  brief: '',
  slug: '',
  created: '',
  updated: '',
  categories: [],
  documents: [],
  insuredUntil: '',
  collectionId: BUSINESS_COLLECTION_ID,
  collectionName: 'businesses',
  description: '',
  facebook: '',
  expand: {
    categories: [],
    openingHours: [],

  },
  gallery: [],
  hidden: false,
  openingHours: [],
  instagram: '',
  linkedin: '',
  logo: '',
  name: '',
  phone: '',
  twitter: '',
  website: '',
  whatsapp: '',
}

export const EVENT_DEFAULT = {
  collectionId: '8l5am0o54mst50n',
  collectionName: 'events',
  id: '',
  name: '',
  image: '',
  title: '',
  dateStart: '',
  dateEnd: '',
  description: '',
  hidden: false,
  business: '',
}

export const OFFER_DEFAULT = {
  collectionId: 'ml28wuiixpuvep9',
  collectionName: 'offers',
  id: '',
  name: '',
  image: '',
  title: '',
  dateStart: '',
  dateEnd: '',
  description: '',
  hidden: false,
  business: '',
}

export const NEWS_DEFAULT = {
  collectionId: 'qm199dn2glrtavp',
  collectionName: 'news',
  id: '',
  name: '',
  slug: '',
  brief: '',
  description: '',
  author: '',
  image: '',
  hidden: false,
  youtube: '',
}

export const PRODUCT_DEFAULT = {
  collectionId: 'tqoon6l7268h2oa',
  collectionName: 'products',
  id: '',
  title: '',
  description: '',
  active: false,
  priceInPence: 0,
  interval: 'month',
  frequency: 0,
}

export const STRIPE_INTERVALS = ['day', 'week', 'month', 'year']
